import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed91dc9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scan-area" }
const _hoisted_2 = { class: "mode-switch" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mode-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mode-icon" }, "📷"),
  /*#__PURE__*/_createTextVNode(" 扫描模式 ")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "mode-buttons" }
const _hoisted_5 = {
  key: 0,
  class: "scanner-mode"
}
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = ["placeholder", "disabled", "onKeyup"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scan-icon" }, "📷", -1 /* HOISTED */))
const _hoisted_9 = { class: "scanner-hint" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hint-icon" }, "ℹ️", -1 /* HOISTED */))
const _hoisted_11 = { class: "camera-mode" }
const _hoisted_12 = { class: "camera-container" }
const _hoisted_13 = {
  ref: "videoElement",
  class: "camera-video",
  playsinline: "",
  autoplay: ""
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-overlay" }, null, -1 /* HOISTED */))
const _hoisted_15 = {
  key: 0,
  class: "camera-placeholder"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-icon" }, "📷", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "camera-tip" }, "请允许相机权限后使用", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 0,
  class: "camera-controls"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⏹️", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🔄", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "camera-hint" }, " 将二维码放入扫描框内自动识别 ", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 模式切换 "),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["mode-btn", { active: $setup.currentMode === 'scanner' }]),
          onClick: _cache[0] || (_cache[0] = $event => ($setup.switchMode('scanner')))
        }, " 🔘 扫描头 ", 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass(["mode-btn", { active: $setup.currentMode === 'camera' }]),
          onClick: _cache[1] || (_cache[1] = $event => ($setup.switchMode('camera')))
        }, " 📱 相机 ", 2 /* CLASS */)
      ])
    ]),
    _createCommentVNode(" 扫描头模式 "),
    ($setup.currentMode === 'scanner')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              ref: "scanInputRef",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.inputValue) = $event)),
              placeholder: $props.placeholder,
              disabled: $props.disabled,
              class: "scan-input",
              onKeyup: _withKeys($setup.handleScan, ["enter"]),
              onFocus: $setup.onFocus,
              onBlur: $setup.onBlur
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
              [_vModelText, $setup.inputValue]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString($setup.hintText), 1 /* TEXT */)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" 相机模式 "),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("video", _hoisted_13, null, 512 /* NEED_PATCH */),
              _hoisted_14,
              (!$setup.isCameraActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "start-camera-btn",
                      onClick: $setup.startCamera
                    }, [
                      _hoisted_16,
                      _createTextVNode(" 开启相机扫码 ")
                    ]),
                    _hoisted_17
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            ($setup.isCameraActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "camera-btn",
                    onClick: $setup.stopCamera
                  }, [
                    _hoisted_19,
                    _createTextVNode(" 停止 ")
                  ]),
                  _createElementVNode("button", {
                    class: "camera-btn",
                    onClick: $setup.switchCamera
                  }, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString($setup.facingMode === 'environment' ? '前置' : '后置'), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_21
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}